import billingTransformer from '@/transformers/Files/billingRequest'
import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Creates a billing request file
 *
 * @param  payload File and id
 * @return {Array} File's info
 */

const createBillingRequest = payload =>
  Vue.$http.post('catalogs/common/billing/request/', billingTransformer.send(payload))
    .then()
    .catch((err) => {
      throw err
    })

export default createBillingRequest


// WEBPACK FOOTER //
// ./src/services/Files/createBillingRequest.js